import axios from "axios";

function getConfig() {
    return axios.get('api/configuracion/getConfig')
}

function editarConfiguracion(data) {
    return axios.put('api/configuracion/editarConfiguracion', data);
}

export {
    getConfig,
    editarConfiguracion
}
